import * as React from "react";

function SvgIconFutureProof(props) {
  return (
    <svg viewBox="0 0 624.06 545.23" {...props}>
      <path
        fill="#32cb87"
        d="M582.85,162.12,371.08,38.6,263,101.15v54.2L160.56,214.63v54.62L57.13,329.11v60.35L269,512l108-61.52V394.9L480.42,336V280.85l102.43-58.37ZM567.77,165l-92.85,52.91L278,104l93-53.83ZM269.05,445.82,72.18,332l93-53.83L361.91,392.91Zm-98.44-219.6L367.45,340v43L170.61,269.19ZM372.49,331.34,175.61,217.52l92.09-53.29L465.29,278.46Zm97.39-104.8v42.91L273,154.64V112.75ZM67.17,340.71,264,454.5v43L67.17,383.67ZM274.06,497.53v-43l92.88-52.92v43ZM377.49,383.05V340l92.88-52.92v43ZM479.92,269.57v-43l92.89-52.93v43Z"
      />
    </svg>
  );
}

export default SvgIconFutureProof;
